
<script>
    import { Line } from 'vue-chartjs'

    export default {
        extends: Line,
        name: "FileLineChart",
        mounted () {
            // Deep merge options to ensure labels are disabled
            const mergedOptions = JSON.parse(JSON.stringify(this.options || {}));
            
            // Ensure plugins object exists
            if (!mergedOptions.plugins) {
                mergedOptions.plugins = {};
            }
            
            // Disable chartjs-plugin-labels
            mergedOptions.plugins.labels = {
                render: () => {
                    return ''; // Return empty string to hide labels
                },
                fontSize: 0,
                fontColor: 'transparent'
            };
            
            // Also disable datalabels if present
            mergedOptions.plugins.datalabels = {
                display: false
            };
            
            mergedOptions.title = { display: true, text: this.title, fontSize: '18' };
            this.renderChart(this.chartdata, mergedOptions)
        },
        props: {
            chartdata: Object,
            options: Object,
            title: String,
            update: Boolean
        },
        watch: {
            update() {
                // Deep merge options to ensure labels are disabled
                const mergedOptions = JSON.parse(JSON.stringify(this.options || {}));
                
                // Ensure plugins object exists
                if (!mergedOptions.plugins) {
                    mergedOptions.plugins = {};
                }
                
                // Disable chartjs-plugin-labels
                mergedOptions.plugins.labels = {
                    render: () => {
                        return ''; // Return empty string to hide labels
                    },
                    fontSize: 0,
                    fontColor: 'transparent'
                };
                
                // Also disable datalabels if present
                mergedOptions.plugins.datalabels = {
                    display: false
                };
                
                mergedOptions.title = { display: true, text: this.title, fontSize: '18' };
                this.renderChart(this.chartdata, mergedOptions)
            }
        },
    }
</script>

<style scoped>

</style>

